import { Directive, Input } from '@angular/core';
import { MatSelect } from '@angular/material/select';

@Directive({
  selector: '[strikePriceScroll]',
})

export class MatSelectStrikePriceScrollDirective {
  @Input() order;
  @Input() strikePrices;
  constructor(public matSelect: MatSelect) {
    this.matSelect.openedChange.subscribe((isOpen: boolean) => {
      if (isOpen && !this.matSelect.value) {
        const priceVal = this.order.quote.sqtLastPrc;
        const closestStrikePrice = this.strikePrices.reduce(function (prev, curr) {
          return (Math.abs(Number(curr.optStrikePrc) - priceVal) < Math.abs(Number(prev.optStrikePrc) - priceVal) ? curr : prev);
        });
        let findElement = this.matSelect.options.toArray().find(item => item.value === closestStrikePrice.optStrikePrc)._getHostElement().offsetTop;
        const panel = this.matSelect.panel.nativeElement as HTMLDivElement;
        panel.scrollTop = findElement - 10;;
      }
    });
  }
}
